import indexPage from '../pages/home/index'
import Detail from '../pages/detail/detail'
// import passport from './passport/index'
// import course from './course/index'
// import my from './my/index'
// import teacher from './teacher/index'
// import page404 from './error/404'
// import mqtt from '../pages/mqtt/index'

const routes = [
  
  {
    path: '/',
    name: 'home',
    component: indexPage,
    props: true,
    meta: {
      title: '升级黄金会员'
    }
  },
  {
    path: '/detail',
    name: 'detail',
    component: Detail,
    props: true,
    meta: {
      title: '升级黄金会员'
    }
  },
/* 
  {
    name: 'any',
    path: '*',
    redirect(to) {
      const { path, query } = to
      return {
        name: 'page404',
        query: {
          path,
          query: JSON.stringify(query)
        }
      }
    }
  } */
]

// add route path
routes.forEach(route => {
  route.path = route.path || '/' + (route.name || '')
  // console.log(route.path);
})

export default routes
